/*
 * @Description:
 * @Date: 2024-04-26 09:52:14
 */
import { mapState } from 'vuex';
import { tipsMessage } from '@/api/ajax';
import { MessageBox } from 'element-ui';

export default {
  data() {
    return {
      /* 
        检查项目维护是否需要提示，每次加载项目只检查一次， false 检查 默认。
        登录页面或未登录都不检查，登录后也会检查一次。
        根据接口状态是否展示，如果接口不需要提示，该标识也置为true
      */
      maintenanceChecked: false
    };
  },
  computed: {
    ...mapState({
      token: state => state.user.token
    })
  },
  methods: {
    async showMaint() {
      // 是否需要检查
      if (
        this.token &&
        !this.maintenanceChecked &&
        this.$route.name !== 'login'
      ) {
        // 只要调用都改为已检查
        this.maintenanceChecked = true;
        // 根据接口是否展示
        const {
          pdata: { content, title, show }
        } = await tipsMessage();
        if (show) {
          MessageBox.confirm(content, title, {
            confirmButtonText: '已知晓',
            showCancelButton: false,
            center: true
          });
        }
      }
    }
  },
  watch: {
    $route() {
      this.showMaint();
    },
    token: {
      immediate: true,
      handler(v) {
        // 退出后改为未检查
        if (!v) {
          this.maintenanceChecked = false;
        }
      }
    }
  }
};
